const TEST_VARIATION_A = 'test_variation_a';
const TEST_VARIATION_B = 'test_variation_b';
const TEST_VARIATION_C = 'test_variation_c';
const CONTROL_GROUP = 1;
const TEST_GROUP = 2;

const getTestVariation = (abTests, testNumber) => {
    const variation = abTests[testNumber];

    if (typeof variation === 'undefined' || variation === '0' || Number(variation) === CONTROL_GROUP) {
        return TEST_VARIATION_A;
    } else if (Number(variation) === TEST_GROUP) {
        return TEST_VARIATION_B;
    } else {
        return TEST_VARIATION_C;
    }
};

const inAbTest = (abTests, testNumber) => {
    const variation = getTestVariation(abTests, testNumber);

    return variation === TEST_VARIATION_B;
};

const allocatedToControlGroup = (abTests, testNumber) =>
    !!abTests && abTests[testNumber] && Number(abTests[testNumber]) === CONTROL_GROUP;

module.exports = {
    TEST_VARIATION_A,
    TEST_VARIATION_B,
    TEST_VARIATION_C,
    CONTROL_GROUP,
    TEST_GROUP,
    allocatedToControlGroup,
    getTestVariation,
    inAbTest,
};
